import { Fragment, h } from 'preact'

import { getElcoConf } from '../../js/modules/getElcoConf.js'
import { SG1Logs } from '../../js/modules/logs.js'

export const Metadata = ({ SEO, partners, technical, sections, idzoneVector }) => {
   try {
      // idzone
      window.o_idzone = idzoneVector

      // Body classes & ID
      document.body.id = getPageId(technical.pageId)
      if (technical.isUserLogged === true) document.body.classList.add('is-logged')
      document.body.classList.add(`is-${technical.deviceType}`)

      // Page Testid
      const testid = `${technical.pageId}`
      document.body.setAttribute('data-testid', testid)

      // Page sections
      const mainElement = document.getElementById('sg1-sections')
      if (mainElement !== null) {
         for (const section of sections) {
            const sectionElement = document.createElement('section')
            sectionElement.id = section
            mainElement.appendChild(sectionElement)
         }
      }

      // datastore
      addDataStore(technical.isUserLogged, getPageId(technical.pageId), technical.pageId, technical.deviceType, technical.featureFlags)

      // dataLayer
      addDatalayer(getPageId(technical.pageId), technical.isUserLogged, technical.deviceType, technical.idTracking, technical.experimentsVariant)

      // Add PDB
      const pdbLoaded = () => {
         const pdbConfig = {
            prefix: 'adv',
            watchedAttributes: ['canal', 'cappingdata'],
            pixelURL: technical.adviseCappingURL,
            method: 'POST',
            plugin: 'adviseCapping',
         }
         try {
            if (window.dataStoreHP.SSEstatus === 'disconnected') {
               o_pdb.init(pdbConfig)
            } else {
               document.addEventListener('sseEndOfTransmition', () => {
                  o_pdb.init(pdbConfig)
               })
            }
         } catch (error) {
            console.error('Pdb capping error')
            SG1Logs.logError(`pdbLoaded : Pdb capping error : ${error.message}`)
         }
      }

      // Add ELCO
      const elcoLoaded = () => {
         // WORKAROUND : Trigger le DOMContentLoaded pour déclencher le header des elcos
         window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
               bubbles: true,
               cancelable: true,
            })
         )

         if (typeof head !== 'undefined') {
            head.ready(function () {
               if (!technical.featureFlags.ff_disable_pdb) {
                  // il faut avoir les elco pour executer le capping advise
                  addScript('', '', 'https://gp.cdn.woopic.com/tools/pdb.min.js', pdbLoaded)
               }

               o_footer()

               if (technical.pageId === 'prospect-nl') {
                  const isSearchFormReady = document.getElementById('searchForm') !== null ? true : false
                  if (isSearchFormReady) {
                     o_generateSearchZone('searchForm', 'hp')
                  } else {
                     document.addEventListener(
                        'generateSearchZone',
                        (event) => {
                           o_generateSearchZone('searchForm', 'hp')
                        },
                        { once: true }
                     )
                  }
               }
            })
         }
      }

      if (!technical.featureFlags.pf_disable_partners) {
         addElcoConf(technical.pageId, technical.appEnv)
         addScript('', '', 'https://c.woopic.com/libs/common/o_load_responsive.js', elcoLoaded)
      }

      // Add AdGateway
      if (partners.adGatewayURL !== '' && !technical.featureFlags.pf_disable_partners) {
         // On attend que tous les id pub soient posés pour déclencher le tag adgateway
         document.addEventListener('sseEndOfTransmition', () => {
            let tag = document.createElement('script')
            tag.src = partners.adGatewayURL
            tag.defer = true
            tag.dataset.testid = 'script-pub'
            document.head.appendChild(tag)
         })
      }
   } catch (error) {
      console.error('metadata orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.logError(`Metadata : ${error.message}`)
   }

   return (
      <Fragment>
         <title>{SEO.title}</title>
         <meta name="description" content={SEO.description} />
         <meta name="robots" content="index, follow" />
         <link href={SEO.canonicalURL} rel="canonical" />
         {partners.facebooksiteverif && <meta name="facebook-domain-verification" content={partners.facebooksiteverif} />}
         {partners.googlesiteverif && <meta name="google-site-verification" content={partners.googlesiteverif} />}
         <script type="application/ld+json">{SEO.jsonLD}</script>
         {technical.featureFlags.pf_cyclope && <script src="https://artifactory.si.francetelecom.fr/mfy-ftaccueilv-generic/cyclope/cyclope.user.js" />}
      </Fragment>
   )
}

const addScript = (type = '', content = '', src = '', callback) => {
   let tag = document.createElement('script')
   src !== '' ? (tag.src = src) : ''
   type !== '' ? (tag.type = type) : ''
   content !== '' ? (tag.textContent = content) : ''
   typeof callback === 'function' ? (tag.onload = callback) : ''
   document.head.appendChild(tag)
}

const addDataStore = (isUserLogged, pageId, refZ, deviceType, featureFlags) => {
   window.dataStoreHP = {
      featureFlags: { ...featureFlags },
      isLogged: isUserLogged,
      pageId: pageId,
      segRefZ: refZ,
      device: deviceType,
   }
}

const getPageId = (refZ) => {
   const listPageId = {
      hp: ['hp', 'hp-nl', 'hp-mob', 'hp-mob-nl'],
      'hp-regulier': ['regulier', 'regulier-nl', 'regulier-mob', 'regulier-mob-nl'],
      'hp-occasionnel': ['occas', 'occas-nl', 'occas-mob', 'occas-mob-nl'],
      'hp-prospect': ['prospect-nl', 'prospect-mob-nl'],
      'vitrine-boutique': ['boutique-nl', 'boutique-mob-nl'],
      'vitrine-boutique-client': ['boutique', 'boutique-mob'],
      'n1-forfaits-prospect': ['mobile-prospect-nl', 'mobile-prospect-mob-nl', 'mobile-prospect', 'mobile-prospect-mob'],
      'n1-forfaits': ['mobile-client-nl', 'mobile-client-mob-nl', 'mobile-client', 'mobile-client-mob'],
      'n1-tv-prospect': ['divert-prospect-nl', 'divert-prospect-mob-nl', 'divert-prospect', 'divert-prospect-mob'],
      'n1-tv': ['divert-client-nl', 'divert-client-mob-nl', 'divert-client', 'divert-client-mob'],
   }

   for (let key in listPageId) {
      if (listPageId[key].includes(refZ)) {
         return key
      }
   }
}

const addDatalayer = (pageId, isUserLogged, deviceType, idTracking, experimentsVariant) => {
   switch (pageId) {
      case 'hp': // version aloha
      case 'hp-regulier':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_regulier',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-occasionnel':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_occasionnel',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'hp-prospect':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp_prospect',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'hp_boutique',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'n1-forfaits-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_mobile_prospect-mobile',
            type_page: 'cremaillere',
            univers_affichage: 'mobile',
         }
         break
      case 'n1-forfaits':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_mobile_client-mobile',
            type_page: 'cremaillere',
            univers_affichage: 'mobile',
         }
         break

      case 'n1-tv-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_prospect-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
      case 'n1-tv':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_client-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
   }
   window.o_data.id_tracking = idTracking
   window.o_data.segment = 'RES'
   window.o_data.sous_univers = 'global'
   window.o_data.canal = deviceType === 'mobile' ? 'Mobile Web' : 'Web'

   deviceType === 'mobile' ? (window.o_data.titre_page += '_webapp') : ''
   isUserLogged === true ? (window.o_data.titre_page += '_logue') : (window.o_data.titre_page += '_non_logue')
   isUserLogged === true ? (window.o_data.type_page += '_logue') : (window.o_data.type_page += '_non_logue')

   // Abtests
   // ajoute des clés/valeur à window.o_data qui portent le nom des "experiment" et "variant"
   // de chaque items de experimentsVariant en supprimant les caractères spéciaux dans les clés
   if (Array.isArray(experimentsVariant)) {
      experimentsVariant.forEach((item) => {
         if (item && typeof item === 'object') {
            window.o_data[item.experiment.replace(/[^a-zA-Z0-9]/g, '')] = item.variant
         }
      })
   }
}

const addElcoConf = (refZ, appEnv) => {
   const listConfNameRefZ = {
      regulier: ['regulier', 'regulier-nl', 'hp'],
      prospect: ['prospect-nl', 'hp-nl'],
      'prospect-regulier-mob': ['regulier-mob', 'regulier-mob-nl', 'prospect-mob-nl', 'hp-mob', 'hp-mob-nl'],
      occas: ['occas', 'occas-nl'],
      'occas-mob': ['occas-mob', 'occas-mob-nl'],
      boutique: ['boutique', 'boutique-nl'],
      'boutique-mob': ['boutique-mob', 'boutique-mob-nl'],
      mobile: ['mobile-prospect', 'mobile-prospect-nl', 'mobile-client', 'mobile-client-nl'],
      'mobile-mob': ['mobile-prospect-mob', 'mobile-prospect-mob-nl', 'mobile-client-mob', 'mobile-client-mob-nl'],
      divert: ['divert-prospect', 'divert-prospect-nl', 'divert-client', 'divert-client-nl'],
      'divert-mob': ['divert-prospect-mob', 'divert-prospect-mob-nl', 'divert-client-mob', 'divert-client-mob-nl'],
   }
   //methode qui retourne la clé de confg qui contient la refZ et affecte la confelco correspondante à o_confCommon
   for (let key in listConfNameRefZ) {
      if (listConfNameRefZ[key].includes(refZ)) {
         window.o_confCommon = getElcoConf(key)
         break
      }
   }

   window.o_confCommon.typeEnv = appEnv === 'dev' || appEnv === 'staging' || appEnv === 'preprod' ? 'rec' : 'prod'
   window.o_confCommon.tracking.refz.page = refZ
}
